import type {
  ICompanyApplicationTenant,
  IHomeLaunchpadRecentlyUsedSolution,
} from "@models";
import { useUserTenants } from "@query";
import { APP_BASE_PATH, mapUserTenantsToApplicationTenants } from "@shared";
import { useMemo } from "react";

interface IUseHomeLaunchpadApplicationsOptions {
  companyUuid: string | undefined;
  userUuid: string | undefined;
  enabled: boolean;
  userInfoLoading: boolean;
  companyLoading: boolean;
}

export function useHomeLaunchpadApplications({
  companyUuid,
  userUuid,
  enabled,
  userInfoLoading,
  companyLoading,
}: IUseHomeLaunchpadApplicationsOptions) {
  const fetchEnabled = enabled && !!companyUuid && !!userUuid;

  const { data: userTenantRows, isLoading: tenantsLoading } = useUserTenants(
    companyUuid,
    userUuid,
    APP_BASE_PATH,
    {
      enabled: fetchEnabled,
    },
  );

  const tenants = useMemo(
    () => mapUserTenantsToApplicationTenants(userTenantRows) ?? [],
    [userTenantRows],
  );

  const recentlyUsedSolutions = useMemo(
    (): IHomeLaunchpadRecentlyUsedSolution[] => [],
    [],
  );

  const isLoading =
    userInfoLoading ||
    (!!companyUuid && !!userUuid && (companyLoading || tenantsLoading));

  return {
    tenants,
    recentlyUsedSolutions,
    isLoading,
  };
}

export type { ICompanyApplicationTenant };
